<div #outsideModal class="modal">
  <div #modalBody class="modal-content">
      <div class="modal-header"> Aperçu CR Bio </div>
      <div class="modal-body">
          <div class="all-container">
            <!-- <div class="button-wrapper" style="margin-bottom: 2rem;">
              <frg-button [type]="'button'" (activated)="switchTo('details')"
                  [backgroundColor]="'var(--primary)'" *ngIf="!!infoReleve.donneesBio">Contenu
              </frg-button>
              <frg-button [type]="'button'" (activated)="switchTo('iframe')"
                  [backgroundColor]="'var(--primary)'">Aperçu généré
              </frg-button>
            </div> -->
            <div class="iframe-container" *ngIf="ongletActif === 'iframe' && !!safeHtml">
              <iframe id="iframeBio" [srcdoc]="safeHtml" frameborder="0" width="100%" height="100%" onload=""></iframe>
            </div>
            <div class="details-container" *ngIf="ongletActif === 'details' && !!infoReleve.donneesBio">
              <div *ngFor="let categorie of infoReleve.donneesBio.categories" class="categorie">
                <div class="categorie-title" *ngIf="categorie.text">
                  <div class="categorie-title-text">{{categorie.text}}</div>
                </div>
                <div class="categorie-title" *ngIf="!categorie.text">
                  <div class="categorie-title-text">{{categorie.displayName}}</div>
                </div>
                <div class="categorie-content">
                  <div *ngFor="let ligne of categorie.lignes" class="ligne" [ngClass]="{'orange': ligne.isError, 'red': ligne.isCriticalError }">
                    <div class="ligne-title" *ngIf="ligne.text">
                      <span class="ligne-title-text">{{ligne.text}}</span>
                      <!-- <div *ngIf="ligne.methodCode" class="ligne-title-method">{{ligne.methodCode}}</div> -->
                    </div>
                    <div class="ligne-title" *ngIf="!ligne.text">
                      <span class="ligne-title-text">{{ligne.displayName}}</span>
                      <!-- <div *ngIf="ligne.methodCode" class="ligne-title-method">{{ligne.methodCode}}</div> -->
                    </div>
                    <div class="ligne-value">
                      <div *ngFor="let value of ligne.values">
                        <div class="value-value" *ngIf="value.displayed">
                          <span *ngIf="value.value">{{unescapeHTML(value.value)}}</span>
                          <div *ngIf="value.low || value.high">
                            <span *ngIf="value.low">{{unescapeHTML(value.low)}}</span>
                            <span *ngIf="value.low && value.high"> - </span>
                            <span *ngIf="value.high">{{unescapeHTML(value.high)}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="ligne-range">
                      <div *ngFor="let value of ligne.values">
                        <div class="value-value" *ngIf="value.referenceRange && value.displayed">
                          <div *ngIf="value.referenceRange.low || value.referenceRange.high">
                            <span *ngIf="!value.referenceRange.low && value.referenceRange.high"> &lt; </span>
                            <span *ngIf="value.referenceRange.low && value.referenceRange.high"> [ </span>
                            <span *ngIf="value.referenceRange.low">{{unescapeHTML(value.referenceRange.low)}}</span>
                            <span *ngIf="value.referenceRange.low && value.referenceRange.high"> - </span>
                            <span *ngIf="value.referenceRange.high">{{unescapeHTML(value.referenceRange.high)}}</span>
                            <span *ngIf="value.referenceRange.low && !value.referenceRange.high"> &gt; </span>
                            <span *ngIf="value.referenceRange.low && value.referenceRange.high"> ] </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="ligne-unit">
                      <div *ngIf="ligne.values.length == 1">
                        <span *ngIf="ligne.values[0].unit">{{ligne.values[0].unit}}</span>
                      </div>
                      <ng-container *ngIf="ligne.values.length > 1">
                        <select (change)="switchValue($event, ligne)">
                          <option *ngFor="let value of ligne.values" [value]="value.unit">
                              {{value.unit}}
                          </option>
                        </select>
                      </ng-container>
                    </div>
                    <div class="ligne-interpretation">
                      <ng-container *ngIf="!!ligne.interpretationCode">
                        {{ligne.interpretationCode.code}} - {{ligne.interpretationCode.displayName}}
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="button-wrapper">
            <frg-button [type]="'reset'" (activated)="closeModal()"
                [backgroundColor]="'var(--darkest-primary)'">Fermer
            </frg-button>
        </div>
      </div>
  </div>
</div>
<div class="modal-background"></div>
